<ng-container *ngIf="!hiddenModal">
<div class="modal-header">
  <h4 class="modal-title">Rental and Expenses</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-spinner
    [name]="'expenses_modal_spinner'"
    [fullScreen]="false"
    type="ball-scale-multiple"
    size="medium">
  </ngx-spinner>
  <form class="form" #rentalDetailForm="ngForm" novalidate>
    <div class="modal-body pt-2">
      <h4>Rental Data</h4>
      <div class="row">
<!--        <div class="col-md-12 col-sm-12 pl-0 pr-0">-->
<!--          <button   *ngIf="!isEdit" type="button" (click)="addNewRow('','','','')"-->
<!--                    class="btn btn-primary btn-xs pull-right mb-3"><span class="pl-2 pr-1">New-->
<!--                    Rent Row</span></button>-->
<!--        </div>-->

        <div class="col-md-12 col-sm-12 text-small table-responsive border">
          <table class="table ">
            <thead>
            <tr>
              <th scope="col">Paid Date</th>
              <th scope="col">Rent Payment (Gross)</th>
              <th  scope="col">Tenant Name</th>
              <th width="10%"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let row of rentalDataClone; let key = index">
              <tr>
                <td style="min-width: 120px !important;">
                  <label class="form-group has-float-label  mb-0">
                    <div class="input-group ">
                      <input class="form-control" placeholder="dd/mm/YYYY"
                             name="rent_paid_date_{{row.randomStr}}"
                             ngbDatepicker #rent_paid_date="ngbDatepicker"
                             (click)="rent_paid_date.toggle()" [(ngModel)]="row.date_s"
                             (ngModelChange)="validateFeild(row,$event)">
                    </div>
                    <div  *ngIf="row.error_count > 0" class="invalid-tooltip">This field is required</div>
                  </label>
                </td>
                <td style="min-width: 120px !important;">

                  <label class="form-group has-float-label has-left-icon-append mb-0">
                    <div class="input-group">
                      <div class="input-group-prepend custom-input-group-append-icon-right-border">
                        <span class="input-group-text custom-input-group-append-icon ">$</span>
                      </div>
                      <input type="number" class="form-control" aria-describedby="inputGroup-sizing-sm"
                             name="rent_per_month_{{row.randomStr}}"
                             [(ngModel)]="row.amount" #per_month="ngModel"
                             required (blur)="amountChange(key,row.amount)" (ngModelChange)="validateAmount(row,$event)">
                    </div>
                    <div  *ngIf="row.error_amount > 0" class="invalid-tooltip">This field is required</div>
                  </label>
                </td>
                <td  style="min-width: 136px !important;">
                  <label class="form-group has-float-label  mb-0">
                    <div class="position-relative has-icon-left">
                      <div class="input-group">
                        <input type="text" class="form-control" aria-describedby="inputGroup-sizing-sm"
                               name="tenant_name_{{row.randomStr}}" [(ngModel)]="row.name" #tenant_name="ngModel"
                               (blur)="tenantChange(key,row.name)">
                      </div>
                    </div>

                  </label>
                </td>
                <td>
<!--                  <div class="table-dropzone overflow-unset" ngx-dropzone [accept]="'.pdf'" #drop1-->
<!--                       (change)=" savePdfs($event,'row_pdf',key)" hidden>-->
<!--                    <ngx-dropzone-label>-->
<!--                      <div>-->
<!--                        <i class="fa fa-plus"></i>-->
<!--                      </div>-->
<!--                    </ngx-dropzone-label>-->
<!--                  </div>-->
                  <div class="row">
                    <div class="form-group pr-2 pt-2 d-flex">
<!--                      <a href="javascript:;" class="badge badge-warning mb-1 mr-1"  ngbTooltip="Browse File"   (click)="drop1.showFileSelector()">-->
<!--                        <i class="glyph-icon simple-icon-paper-clip f-15"></i>-->
<!--                      </a>-->
                      <a *ngIf="rentalDataClone.length > 1" href="javascript:;" class="badge badge-primary mb-1 mr-1"  ngbTooltip="Add Row"   (click)="addRow(key,row)">
                        <i class="fa fa-plus f-15" style="font-weight: 500;"></i>
                      </a>
                      <a *ngIf="rentalDataClone.length > 0" href="javascript:;" class="badge badge-danger mb-1 mr-1"  ngbTooltip="Delete"   (click)="removeRecord(row.randomStr)">
                        <i class="glyph-icon simple-icon-trash f-15"></i>
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
<!--              <tr *ngIf="row.media.length !=0">-->
<!--                <td colspan="4" class="pb-2 pt-2">-->
<!--                  <div class="row">-->
<!--                    <ng-container *ngFor="let media of row.media; let key_media = index">-->
<!--                      <div class="col-md-3" *ngIf="media.full_url!=''">-->
<!--                        <a class="cursor-pointer " tooltip="{{media.file_name}}"><span class="f-11" (click)="mediaDownload(media)">{{ media.file_name  | slice:0:20 }}</span>-->
<!--                          <span-->
<!--                            *ngIf="media['file_name'].length >20 ">...</span> <i-->
<!--                            class="fa fa-remove text-danger ml-2"-->
<!--                            (click)="removePdfRental(key,media.file_name,key_media)"></i></a>-->
<!--                      </div>-->
<!--                    </ng-container>-->
<!--                  </div>-->
<!--                </td>-->
<!--              </tr>-->
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <h4 class="pt-2">Expense Data</h4>
      <div class="row">

        <div class="col-md-4 mb-3" *ngFor="let row_data of dataArray; let key = index">
          <div class="border p-3 position-relative">
            <button
              type="button"
              class="close remove-btn"
              (click)="removeExpenses(key)">
              &times;
            </button>
            <div class="form-group mt-1">
              <label class="form-group has-float-label mb-0 " *ngIf="!properties['is_custom_pick_list']">
                <div class="position-relative has-icon-right">
                  <div class="input-group">
                    <select  class="form-control form-control-sm full-width" name="expense_category_id_{{row_data.randomStr}}" [(ngModel)]="row_data.expense_category"   #ex_type_{{row_data.randomStr}}="ngModel"  (click)="clearTooltip( key)" (change)="changeDuplicateValue(row_data,key); getLastExpense(row_data, key);" style="min-width: 200px;" required>
                      <option value="undefined" selected disabled>Select</option>
                      <option  *ngFor="let  type of  category_type" value="{{type.expense_category}}" >{{type.expense_category}}</option>
                    </select>
                  </div>
                </div>
                <span> Category<span class="text-danger">*</span></span>
                <div  class="invalid-tooltip" *ngIf="row_data.isValidateCategory ">This field is required</div>

              </label>
              <label class="form-group has-float-label has-right-icon-append " *ngIf="properties['is_custom_pick_list']" >
                <div class="input-group">
                  <ng-select [items]="category_type"
                             [addTagText]="'Hit Enter to Add Item'"
                             aria-describedby="inputGroup-sizing-sm"
                             name="expense_category_id_{{row_data.randomStr}}"
                             [hideSelected]="true"
                             [multiple]="false"
                             bindLabel="expense_category"
                             bindValue="expense_category"
                             #b_material="ngModel"
                             [selectOnTab]="true"
                             [(ngModel)]="row_data.expense_category"
                             [addTag]="addExpenseCategory"
                             class="w-88-prc"
                             (click)="clearTooltip(key)"
                             (clear)="clearSupplier();"
                             (change)="changeDuplicateValue(row_data,key);getLastExpense(row_data, key);" required>
                  </ng-select>
                  <div class="input-group-append" >
                    <button class="btn btn-primary default pl-2 pr-2" style="border-radius: unset!important;" type="button" (click)="openExpenseCategoryModel(expenseCategoryModel,'new_expense',key)"><i
                      class="fa fa-pencil text-white"></i></button>
                  </div>
                </div>
                <span>Customize Category</span>
              </label>
            </div>
            <div class="form-group">
              <label class="form-group has-float-label mb-0 ">
                <div class="input-group">
                  <input class="form-control form-control-sm" placeholder="dd/mm/YYYY"
                         name="payment_date_{{row_data.randomStr}}"
                         style="min-width: 100px!important;"
                         ngbDatepicker #payment_date="ngbDatepicker"
                         (click)="payment_date.toggle()"
                         [(ngModel)]="row_data.payment_date"
                         [autoClose]=calenderAutoClose
                         (ngModelChange)="changeDuplicateValue(row_data,key);isDateValidation(row_data, key)"
                         (blur)="dateValidation(row_data)"
                         placement="" required>
                </div>
                <span>Date Paid<span class="text-danger">*</span></span>
                <!--                      <div class="invalid-tooltip"*ngIf="!payment_Date.valid">This field is required.</div>-->
                <div class="invalid-tooltip"*ngIf="row_data.isValidateDate ">This field is required.</div>
              </label>
            </div>
            <div class="form-group">
              <label class="form-group has-float-label has-left-icon-append">
                <div class="input-group">
                  <div class="input-group-prepend custom-input-group-append-icon-right-border" style="background-color:white; ">
                    <span class="input-group-text custom-input-group-append-icon ">$</span>
                  </div>
                  <input type="number" class="form-control form-control-sm" aria-describedby="inputGroup-sizing-sm" name="amount_{{row_data.randomStr}}" [(ngModel)]="row_data.amount"
                         #per_month="ngModel"  (focus)="clearTooltipAmount($event,key)"  (change)="changeDuplicateValue(row_data,key)" required>
                </div>
                <span>Amount (Gross)<span class="text-danger">*</span></span>
                <div class="invalid-tooltip"*ngIf="row_data.isValidateAmount ">This field is required.</div>
              </label>
            </div>
            <div class="form-group">
              <label class="form-group has-float-label ">
                <div class="input-group">
                  <textarea class="form-control form-control-sm" rows="2" aria-describedby="inputGroup-sizing-sm" name="description_{{row_data.randomStr}}" [(ngModel)]="row_data.description"   (change)="changeDuplicateValue(row_data,key)" #r_name_{{key}}="ngModel" style="max-height: unset !important;"></textarea>
                </div>
                <span class="text-small">Expense Description</span>
              </label>

            </div>
            <div class="form-group">
              <label class="form-group has-float-label has-right-icon-append " >
                <div class="input-group">
                  <ng-select [items]="suppliers"
                             [addTagText]="'Hit Enter to Add Item'"
                             aria-describedby="inputGroup-sizing-sm"
                             name="supplier_{{row_data.randomStr}}"
                             [hideSelected]="true"
                             [multiple]="false"
                             bindLabel="showing_name"
                             bindValue="business_name"
                             #insur="ngModel"
                             [selectOnTab]="true"
                             [(ngModel)]="row_data.business_name"
                             [addTag]="addNewSupplier"
                             class="w-88-prc"
                             (keyup)="searchValue($event)"
                             (clear)="clearSupplier();"
                             (change)="supplierChange($event,key,'add-expense')" required>
                  </ng-select>
                  <div class="input-group-append" >
                    <button class="btn btn-primary default pl-2 pr-2" style="border-radius: unset!important;" type="button" (click)="openSupplierListModel(key,'add-expense')"><i
                      class="fa fa-binoculars text-white"></i></button>
                  </div>
                </div>
                <span>Supplier of Expense</span>
              </label>
            </div>

            <div class="form-group" *ngIf="row_data.is_error ==true">
              <div   class="text-danger pr-1 pt-2">{{row_data.error_message }}</div>
            </div>
        </div>


      </div>
        <div class="col-md-4 mb-3">
          <div class="border p-3 placeholder-box" (click)="addExpenseRow()">

            <button type="button" class="add-btn">+</button>

          </div>
        </div>
      <input type="hidden" name="property_ref" [(ngModel)]="propertyRef" />
    </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary expense-btn" (click)="saveRentalandExpenses(rentalDetailForm);">Save</button>
  <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
</div>
</ng-container>
